//
//
//
//
//
//
import api from '@/api';
import util from '@/libs/util';
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created: function created() {
    this.i18nHandle(this.$i18n.locale); // api.AnnounceTypes()
  },
  mounted: function mounted() {//如果再vue中将判定放置在mountde
    // document.addEventListener('visibilitychange', function (e) {
    //   let state = document.visibilityState
    //   if (state == 'hidden') {
    //   }
    //   if (state == 'visible') {
    //     api.AnnounceTypes()
    //   }
    // });
  },
  methods: {
    i18nHandle: function i18nHandle(val, oldVal) {
      util.cookies.set('lang', val);
      document.querySelector('html').setAttribute('lang', val);
    }
  }
};